import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { channelAPI } from '../services/api';
import { useWebSocket } from '../context/WebSocketContext';
import LogTable from '../components/LogTable';
import RealtimeBadge from '../components/RealtimeBadge';

const ChannelLogs = () => {
    const { channelKey } = useParams();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({ page: 1, limit: 50, total: 0, pages: 0 });
    const [channelInfo, setChannelInfo] = useState(null);
    const { subscribe } = useWebSocket();

    const fetchLogs = useCallback(async (page = 1) => {
        try {
            setLoading(true);
            const res = await channelAPI.getChannelLogs(channelKey, { page, limit: 50 });
            setLogs(res.data.logs);
            setPagination(res.data.pagination);
            if (res.data.logs.length > 0) {
                const first = res.data.logs[0];
                setChannelInfo({ label: first.channelLabel, group: first.channelGroupLabel, color: first.channelGroupColor });
            }
        } catch (e) {
            toast.error('Không thể tải logs');
        } finally {
            setLoading(false);
        }
    }, [channelKey]);

    useEffect(() => { fetchLogs(1); }, [fetchLogs]);

    // Realtime: prepend new logs from this channel
    useEffect(() => {
        const unsub = subscribe('log_new', (log) => {
            if (log.channelKey === channelKey) {
                setLogs(prev => [log, ...prev.slice(0, 49)]);
                setPagination(prev => ({ ...prev, total: prev.total + 1 }));
            }
        });
        return unsub;
    }, [subscribe, channelKey]);

    return (
        <div className="logs-page">
            <div className="logs-header">
                <div className="logs-title-row">
                    <h1>#{channelInfo?.label || channelKey}</h1>
                    <RealtimeBadge />
                </div>
                <p className="logs-subtitle" style={{ color: channelInfo?.color || '#6366f1' }}>
                    {channelInfo?.group} • {pagination.total?.toLocaleString()} logs
                </p>
            </div>
            <LogTable logs={logs} loading={loading} pagination={pagination} onPageChange={fetchLogs} />
        </div>
    );
};

export default ChannelLogs;
